import React, { useEffect, useState } from "react";
import InputSearch from "./InputSearch";
import { Link } from "react-router-dom";
import "./Hero.scss";

export default function Hero({ api }) {
  const [topics, setTopics] = useState([]);

  useEffect(() => {
    api(`api/providers/${process.env.REACT_APP_SLUG}/topics/?page_size=12`, {
      ignoreError: true,
    }).then(({ body }) => {
      setTopics(body?.data);
    });
  }, [api]);

  return (
    <section className="bw-event-hero">
      <div className="bw-event-container">
        <div className="wrapper-text">
          <h1>Engagement Portal</h1>
          <h3>
            Why choose one platform for managing content? Bring all your digital
            content together- no matter the source- with the BW Engagement Portal.
            Learn about our personalization, bookmarking, progressive profiling
            and much more.
          </h3>
        </div>
        <div className="wrapper-search">
          <InputSearch />
          {topics.length ? (
            <>
              <p>Trending:</p>
              <div className="trends">
                {topics.map((item) => (
                  <p key={item.id}>
                    <Link to={"/search?search=" + item.name}>{item.name}</Link>
                  </p>
                ))}
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
    </section>
  );
}
